import React from 'react';
import { Quote } from 'lucide-react';
import { useSite } from '../context/SiteContext';

const Testimonials = () => {
  const { testimonials = [] } = useSite();
  return (
    <section id="testimonials" className="section pt-0">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="text-xs uppercase tracking-[0.24em] text-brand-green-light">Client voices</p>
            <h2 className="mt-3 text-3xl md:text-4xl font-bold text-white">
              What partners say about us.
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => {
            const accents = ['text-brand-pink-light', 'text-brand-teal-light', 'text-brand-amber'];
            const dots = ['bg-brand-pink', 'bg-brand-teal', 'bg-brand-amber'];
            return (
              <figure
                key={t.name}
                className="rounded-2xl p-6 border border-white/8 bg-white/[0.02] card-lift"
              >
                <Quote className={`h-6 w-6 ${accents[i % accents.length]}`} />
                <blockquote className="mt-4 text-slate-200 leading-relaxed">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-6 flex items-center gap-3">
                  <div className={`h-10 w-10 rounded-full ${dots[i % dots.length]} text-black flex items-center justify-center font-semibold`}>
                    {t.name.split(' ').map((n) => n[0]).slice(0, 2).join('')}
                  </div>
                  <div>
                    <div className="text-sm text-white font-medium">{t.name}</div>
                    <div className="text-xs text-slate-400">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
